import { render, staticRenderFns } from "./PendingUploads.vue?vue&type=template&id=6ec5b7ce&"
import script from "./PendingUploads.vue?vue&type=script&lang=js&"
export * from "./PendingUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports